// IMPORTS


/**
 * Exporting "default" so that the import doesn't have to be named in other components.
 * To create named and/or multiple exports, use: export cont compName = {}
 * Remember to import any reactive features from 'vue' if you need reactivity (e.g. computed, ref, reactive, etc.)
 */
export default {
    /* Name the component for easy reference */
    name: 'SponsorCornerBox',

    /* Any imported component for this file needs to be listed here */
    components: {
        
    },

    /* Declare any expected props here */
    props: {
        sponsorLogo: {
            type: String,
            required: false,
            default: ''
        },
        sponsorLink: {
            type: String,
            required: false,
            default: ''
        },
        sponsorBgColor: {
            type: String,
            required: false,
            default: ''
        }
    },

    /* All component logic goes here in setup(). Anything complex or verbose should be handled in an external file,
        using this as more of a "controller" for the component.
    */
    setup(props) {
        

        /* We need to return any variables/functions that we want to use in our template below. */
        return {
            props
        }
    },

    /* Define the template that will be displayed for this component (optional) */
    template: /*html*/`
        <div class="cfm_ec_widget_corner_sponsor_box"
        :style="{backgroundColor: props.sponsorBgColor}"
        v-if="props.sponsorLogo"
        >
            
            <a v-if="props.sponsorLink" :href="props.sponsorLink" target="_blank">
                <img :src="props.sponsorLogo" alt="">
            </a>

            <template v-else>
                <img :src="props.sponsorLogo" alt="">
            </template>

        </div>
    `,
}